(function($) {
    $(document).ready(function() {
        if ($('.col-four-video').length > 0) {

            // $('.col-four-video .col-four > a').html("Read More");

            $(".col-four-video.col-four-video-grid .text-wrap > a").each(function() {
                var anchor = $(this).clone();
                if (anchor) {
                    $(this).parent().parent().append(anchor);
                    $(this).parent().parent().addClass("link");
                }
            });

            $('.col-four-video').each(function() {
                var len = $(this).find('.row-wrap .col-four').length;

                if (len == 3) {
                    $(this).addClass('three-col');
                } else if (len == 2) {
                    $(this).addClass('two-col');
                } else if (len == 1) {
                    $(this).addClass('one-col');
                }
            });
            $('.col-four-video .col-four h4').dotdotdot({
                height: 88,
                fallbackToLetter: true,
                watch: true,
            });
            $('.col-four-video .col-four p').dotdotdot({
                height: 81,
                fallbackToLetter: true,
                watch: true,
            })

            setTimeout(function () {
                $(".col-four-video.col-four-video-carousel .row-wrap ").css({ opacity: "1" });
              }, 500);
              if ($(".col-four-video.col-four-video-carousel .row-wrap .col-four").length > 3) {
                  $(".col-four-video.col-four-video-carousel .row-wrap ").slick({
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      dots: false,
                      arrows: true,
                      autoplay: true,
                      autoplaySpeed: 1500,
                      speed: 1500, 
                      pauseOnFocus: false,      
                      responsive: [
                    
                          {
                              breakpoint: 1024,
                              settings: {
                                  slidesToShow: 3,
                                  draggable: true,
                              },
                          },
                          {
                              breakpoint: 767,
                              settings: {
                                  slidesToShow: 2,
                                //   dots: true,
                                //   arrows: false,
                              },
                          },
                          {
                            breakpoint: 595,
                            settings: {
                                slidesToShow: 1,
                                // dots: true,
                                // arrows: false,
                            },
                        },
                      ],
                  });
                  $(".testimonial-slider .bg-img").slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: false,
                      arrows: false,
                      infinite: true,
                      asNavFor: '.testimonial-slider .row-wrap .slider-wrap',
                      focusOnSelect: true,
                  })
              }
        }
        // $(' .col-four-video .col-four a').click(function (e) {
        //     if ($(this).siblings('.play-btn.video-active').length > 0) {
        //         e.preventDefault();
        //         $(this).parents('.col-four').find('.play-btn').trigger('click');
        //     }
        //     else {
        //         window.location.href = $(this).attr('href');    
        //     }
        // });
    });
})(jQuery);